module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0yMSAyMUg2LjJDNS4wNzk4OSAyMSA0LjUxOTg0IDIxIDQuMDkyMDIgMjAuNzgyQzMuNzE1NjkgMjAuNTkwMyAzLjQwOTczIDIwLjI4NDMgMy4yMTc5OSAxOS45MDhDMyAxOS40ODAyIDMgMTguOTIwMSAzIDE3LjhWM003IDE1TDEyIDlMMTYgMTNMMjEgNyIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4NCjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Menu/chart.svg
// module id = 1967
// module chunks = 9